import Vue from "vue";
import Vuelidate from "vuelidate";

import { onLCP, onFID, onCLS } from "web-vitals";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./Mixins/filters";

import "./assets/css/tailwind.css";
import "./assets/css/polaris.css";

// import "@shopify/polaris/build/esm/styles.css";

Vue.config.productionTip = false;

window.serverURL = process.env.VUE_APP_SERVER_URL;

Vue.use(Vuelidate);

onCLS(console.log);
onFID(console.log);
onLCP(console.log);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
